import { Column } from "@ant-design/plots";
import React, { forwardRef, useImperativeHandle, useMemo, useRef } from "react";
import CommonEmpty from "./commonEmpty";
// 柱状图
const ColumnDom = forwardRef((props, ref) => {
  const { dataList } = props;
  const ColumnDomFn = useMemo(() => {
    const config = {
      appendPadding: [18, 5, 5, 5],
      data: dataList,
      xField: "code",
      yField: "value",
      color: "#03BF8A",
      label: {
        // 可手动配置 label 数据标签位置
        position: "top",
        offsetY: 8,
        style: {
          color: "#333333",
          fontWeight: 700,
        },
        formatter(text, list) {
          // 字符太长添加省略号
          return text?.value?.toFixed(2);
        },
      },
      xAxis: {
        label: {
          autoHide: true,
          autoRotate: false,
          formatter(text, list) {
            const filterData = dataList.filter((item) => {
              return item.code == text;
            });
            const getName = filterData[0].name;
            //根据数组长度计算剩余值
            const calculate = 24 / dataList.length;
            // 字符太长添加省略号
            return getName?.length > calculate
              ? getName?.slice(0, calculate - 1) + "..."
              : getName;
          },
        },
      },
      tooltip: {
        title: "排放量",
        fields: ["name", "summaryValue"],
        formatter: (data) => {
          // console.
          return { name: data.name, value: data.summaryValue };
        },
      },
      legend: {
        position: "bottom",
      },
      slider: false,
      meta: {
        type: {
          alias: "类别",
        },
        value: {
          alias: "排放量",
        },
      },
      maxColumnWidth: 23,
    };
    if (dataList?.length > 0) {
      return <Column style={{ height: "100%" }} {...config} />;
    } else {
      return <CommonEmpty />;
    }
  }, [dataList]);
  return ColumnDomFn;
});

export default ColumnDom;
